import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  gtmContainerId: 'GTM-WZXPXV73',
  analyticsEnv: 'sandbox',
  firebase: {
    apiKey: 'AIzaSyA6OWATCu-nQRMK1oe07ZUWBHXI7ku7NRI',
    authDomain: 'spog-gopher-sandbox.firebaseapp.com',
    projectId: 'spog-gopher-sandbox',
    storageBucket: 'spog-gopher-sandbox.firebasestorage.app',
    messagingSenderId: '285625500192',
    appId: '1:285625500192:web:0c4bdba7f3bfb9bd263245',
  },
  urls: {
    backendApi: 'https://spog-backend.sandbox.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  revision: REVISION,
  version: VERSION,
};
